import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { StatusService } from '../services/status/status.service';

@Injectable()
export class MiddlewareGuard {

  constructor(public statusService: StatusService){  

  }

  canActivate(next: ActivatedRouteSnapshot): boolean {
    this.statusService.empresa_id = next.params.empresa_id;
    this.statusService.grupo_id = next.params.grupo_id;
    this.statusService.sucursal_id = next.params.sucursal_id;
    return true;
  }

}
